import { Container } from 'pixi.js';
import type { Scene } from '../app/SceneManager';
import { VersusSceneController } from './VersusSceneController';
import type { App } from '../app/App';
import level1 from '../../levels/pvp/versus - lvl1.json';
import level2 from '../../levels/pvp/versus - lvl2.json';
import level3 from '../../levels/pvp/versus - lvl3.json';
import level4 from '../../levels/pvp/versus - lvl4.json';
import level5 from '../../levels/pvp/versus - lvl5.json';
import MathUtils from '../utils/MathUtils';
import type { LevelData } from '../game/level/LevelData';


export class VersusGameScene implements Scene {
  public readonly id = 'PVP';

  public readonly view = new Container();

  private readonly app: App;

  private readonly gameSceneController: VersusSceneController;

  constructor(public readonly options: { app: App }) {
    this.app = options.app;

    this.gameSceneController = new VersusSceneController(
      {
        app: this.app,
        root: this.view,
      },
      {
        levelData: MathUtils.rnd.pick([
          level1,
          level2,
          level3,
          level4,
          level5
        ]) as unknown as LevelData,
      }
    );
  }

  public onActivated(): void {
    this.gameSceneController.activate();
  }

  public update(deltaTime: number): void {
    this.gameSceneController.update(deltaTime);
  }

  public resize(): void {
    //
  }

  public destroy(): void {
    this.gameSceneController.destroy();
  }
}
